import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '@store/saga';
import * as Sentry from '@sentry/react';
import rootReducer from './reducers';
const sagaMiddleware = createSagaMiddleware();
const sentryReduxEnhancer = Sentry.createReduxEnhancer();
export function configureAppStore(preloadedState) {
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: {
                ignoredActionPaths: ['meta.arg', 'payload.callback', 'async.recordedChunks.0.data', 'payload.chunk.data'],
            },
        }).concat(sagaMiddleware),
        preloadedState,
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
        devTools: process.env.NODE_ENV !== 'production',
    });
    if (process.env.NODE_ENV !== 'production' && module?.hot) {
        module?.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
    }
    sagaMiddleware.run(rootSaga);
    return store;
}
export const store = configureAppStore({});
export default store;
